import styled from "styled-components";

const InputVal = styled.input`
    display: block;
    width: 100%;
    border: none;
    /* cursor: pointer; */
    padding: 20px 30px;
    border-radius: 20px;
    margin-bottom: 20px;
    transition-duration: 5s;
    &:focus {
        outline: none;
        transition-duration: 5s;
        scale: 1.01;
    }
`

function Input({type, placeholder}) {
    return (
        <InputVal type={type} placeholder={placeholder}/>
    )
}

export default Input;